export const GET_AGENT_INBOX = "GET_AGENT_INBOX";
export const SHOW_AGENT_INBOX = "SHOW_AGENT_INBOX";
export const CREATE_AGENT_INBOX = "CREATE_AGENT_INBOX";
export const DROPDOWN_AGENT_INBOX = "DROPDOWN_AGENT_INBOX";